import { useQuery } from '@tanstack/react-query'
import { shiftService } from '../services/shiftService'
import { toApiError } from '../utils/apiError'
import { PENDING_HANDOFFS_QUERY_KEY, HANDOVER_POLL_MS } from '../constants/handoverConstants'
import { useAuthStore } from '../../auth/store/authStore'
import { isHandoffManager } from '../utils/shiftPermissions'
import type { ShiftHandoffResponse } from '../types/shift.types'

export function usePendingHandoffs(): { handoffs: ShiftHandoffResponse[]; isForbidden: boolean } {
  const user = useAuthStore((s) => s.user)
  const query = useQuery<ShiftHandoffResponse[]>({
    queryKey: [PENDING_HANDOFFS_QUERY_KEY],
    queryFn: () => shiftService.getPendingHandoffs(),
    enabled: isHandoffManager(user),
    retry: false,
    refetchInterval: (q) => (q.state.error ? false : HANDOVER_POLL_MS),
    meta: { silent: true, source: 'usePendingHandoffs' },
  })
  const isForbidden = query.error ? toApiError(query.error).kind === 'forbidden' : false
  return { handoffs: query.data ?? [], isForbidden }
}
